import './style.modules.scss'

import { Breadcrumb, LinkProps } from '@ampcore/adel-react'
import React, { useMemo } from 'react'
import xss from 'xss'

import { createSiteNavAnalyticsClickHandlers } from '../AppBar/siteNavAnalyticsClickHandlers'

export type BreadcrumbTrailProps = {
  links: LinkProps[]
  isDisabled?: boolean
  isReversed?: boolean
  testId?: string
}

export const BreadcrumbTrail: React.FC<BreadcrumbTrailProps> = props => {
  const { links, isDisabled = false, isReversed = false, testId } = props
  const { handleBreadcrumbClick } = createSiteNavAnalyticsClickHandlers()
  const transformedLinks = useMemo(() => {
    const baseLinks: LinkProps[] = links.map(l => ({
      ...l,
      onClick: e => handleBreadcrumbClick(e)
    }))

    if (
      typeof document !== 'undefined' &&
      document.referrer &&
      document.referrer.includes('/resource-center') &&
      baseLinks.length === 3 &&
      baseLinks[0].name === 'Financial Goals & Priorities'
    ) {
      const newLinks = baseLinks.map(l => ({ ...l }))
      newLinks[1].name = 'Your resources'
      newLinks[1].url = xss(document.referrer)
      newLinks[1].onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault()
        handleBreadcrumbClick(e)
        globalThis.history.back()
      }
      return newLinks
    }

    return baseLinks
  }, [links, handleBreadcrumbClick])

  if (isDisabled || !transformedLinks || transformedLinks.length <= 1) {
    return null
  }

  return (
    <section className="BreadcrumbTrail" data-testid={testId}>
      <div className="u-sizeConstrained">
        <div className="BreadcrumbTrail-wrapper">
          <Breadcrumb
            links={transformedLinks}
            isReversed={isReversed}
            testId={testId}
          />
        </div>
      </div>
    </section>
  )
}
